import React from 'react';

/**
 * @returns {JSX.Element} PercentIcon svg
 */
export default function PercentIcon() {
  return (
    <svg
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.5 4.99951L5.5 18.9995'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7 8.99951C8.38071 8.99951 9.5 7.88022 9.5 6.49951C9.5 5.1188 8.38071 3.99951 7 3.99951C5.61929 3.99951 4.5 5.1188 4.5 6.49951C4.5 7.88022 5.61929 8.99951 7 8.99951Z'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18 19.9995C19.3807 19.9995 20.5 18.8802 20.5 17.4995C20.5 16.1188 19.3807 14.9995 18 14.9995C16.6193 14.9995 15.5 16.1188 15.5 17.4995C15.5 18.8802 16.6193 19.9995 18 19.9995Z'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
